import { Component, Input, EventEmitter, Output, SimpleChanges, OnChanges, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidatorFn } from '@angular/forms';
import { Observable, combineLatest } from 'rxjs';
import { map, startWith} from 'rxjs/operators';
import { BasicWithLibelleModel } from 'src/app/shared/models/basic/basicWithLibelle.model';


@Component({
  selector: 'app-autocomplete-with-num',
  templateUrl: './autocomplete-with-num.component.html',
  styleUrls: ['./autocomplete-with-num.component.scss']
})
export class AutoCompleteWithNumComponent implements OnChanges {

  @Input() objets: BasicWithLibelleModel[];
  @Input() objet: string;
  @Input() selectedObjet: BasicWithLibelleModel[];
  @Input() required: boolean;
  @Input() parent: UntypedFormGroup;
  @Input() formControlName: string;
  @Input() libelle: string;
  @Output() objetChange = new EventEmitter<string>();
  @Output() loadData =  new EventEmitter<string>();
  @ViewChild('matInput') matInput: ElementRef<HTMLInputElement>;

  objetsString: string[] = [];
  filteredObjets: Observable<string[]>;
  myControl = new UntypedFormControl();

  constructor(private detector: ChangeDetectorRef) { }

  reLoadObjets(): void {
    this.objetsString = [];
    if (this.objets) {
      this.objets = [...new Map(this.objets.map(item => [item['code'], item])).values()];
      for (const objet of this.objets) {
        this.objetsString.push(objet.code);
      }
      this.objetsString.sort((a, b) => a.localeCompare(b));
      this.filteredObjets = this.myControl.valueChanges.pipe(
        startWith(null),
        map((obj: string | null) => obj ? this._filter(obj) : this.objetsString));
      if (this.required) {
        this.myControl.setValidators(forbiddenNamesValidator(this.objets));
      }
    } else {
      combineLatest([this.myControl.valueChanges])
      .subscribe(([value]) => {
        if (value.length > 1) {
          this.loadData.emit(value);
        } else {
          this.loadData.emit(null);
        }
      });
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.reLoadObjets();
    if (this.objet && changes.objet && (this.myControl.value !== changes.objet.currentValue)) {
      this.myControl.setValue(this.objet);
    }
    if(changes.objet && (changes.objet.currentValue === '' || changes.objet.currentValue === null)) {
        this.myControl.setValue('');
        this.detector.detectChanges();
    }
  }

  deleteIfEmptyOrNotFound(): void {
    this.myControl.setValue('');
    this.objet = '';
    this.objetChange.emit('');
  }

  /* selected event MatAutocompleteSelectedEvent*/
  onObjetChange(value: string): void {
    let objet: BasicWithLibelleModel;
    if (value === '') {
      objet = null;
      this.objet = '';
    } else {
      objet = this.objets.find(obj => obj.code === value);
      if (objet) {
        this.objet = objet.code;
        this.myControl.setValue(objet.code);
      } else {
        this.objet = value;
      }
    }
    this.objetChange.emit(this.objet);
    this.reLoadObjets();
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.objetsString.filter(obj => obj.toLowerCase().indexOf(filterValue) >= 0).slice(0, 30);
  }
}

export function forbiddenNamesValidator(names: BasicWithLibelleModel[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    // below findIndex will check if control.value is equal to one of our options or not
    if (control.value && names) {
      const index = names.findIndex(name => {
        return (name.code + '-' + name.libelle).localeCompare(control.value) === 0;
      });
      return index < 0 ? { 'forbiddenNames': { value: control.value } } : null;
    }
    return null;
  };
}
